import {
  FETCHED_USER_ROLE,
  FETCH_ADVERTISER_ERROR,
  FETCH_ADVERTISER_LIST,
  FETCH_ADVERTISER_REQUEST,
  FETCH_ANDROID_CAMPAIGN_COUNT,
  FETCH_CAMPAIGN_ERROR,
  FETCH_CAMPAIGN_LIST,
  FETCH_CAMPAIGN_LIST_BY_ADVERTISER,
  FETCH_ERROR,
  FETCH_IOS_CAMPAIGN_COUNT,
  FETCH_ORG_LIST,
  FETCH_REQUEST,
  RESET_CAMPAIGN_COUNT,
  SET_ADVERTISER,
  SET_ADVERTISER_FILTERED_DATA,
  SET_CAMPIGN_LIST_SELECTED,
  FETCH_ALL_DASHBOARD_USER_LIST,
  FETCH_MAILER_SKAN_CAMPAIGNS_REQUEST,
  FETCH_MAILER_SKAN_CAMPAIGNS_SUCCESS,
  FETCH_MAILER_SKAN_CAMPAIGNS_FAILURE,
  FETCH_MAILER_REGULAR_CAMPAIGNS_REQUEST,
  FETCH_MAILER_REGULAR_CAMPAIGNS_SUCCESS,
  FETCH_MAILER_REGULAR_CAMPAIGNS_FAILURE,
  CLEAR_MAILER_CAMPAIGNS
} from './advertiserTypes';

import { fetchRequestWow } from '../wow/wowActions';
import { FETCH_WOW_REQUEST, CLEAR_WOW_LOADING } from '../wow/wowTypes';

import BASE_URL from '../config';
import advertiserData from 'assets/data/advertiser.json';
import axios from 'axios';
import campaignData from 'assets/data/campaigns.json';

axios.defaults.timeout = 120000; // time in ms to handle logout session
const timeout = 120000; // time in ms to handle logout session

export const fetchFailure = (error) => {
  return {
    type: FETCH_ERROR,
    payload: []
  };
};

// Clear mailer campaigns action
export const clearMailerCampaigns = () => ({
  type: CLEAR_MAILER_CAMPAIGNS
});

export const fetchAdvertiserListFailure = (error) => {
  //console.log('inside fetchAdvertiserListFailure===>');

  return {
    type: FETCH_ADVERTISER_ERROR,
    payload: []
  };
};
export const fetchRequest = (msg) => {
  //console.log("fetchRequest-->")

  return {
    type: FETCH_REQUEST,
    payload: []
  };
};
export const fetchCampaignError = (msg) => {
  return {
    type: FETCH_CAMPAIGN_ERROR,
    payload: msg
  };
};
export const fetchAdvertiserData = (msg) => {
  //console.log('fetching=====>');
  return {
    type: FETCH_ADVERTISER_REQUEST,
    payload: []
  };
};
export const resetCampaignCount = (msg) => {
  return {
    type: RESET_CAMPAIGN_COUNT,
    payload: msg
  };
};
// Old Logic - Before Sep 11, 2025
// export const setFetchedAdvertiserList = (advertiser_list) => {
//   console.log('advertiser_list Role', advertiser_list);
//   // console.log('User Role ===>', advertiser_list.role);
//   return {
//     type: FETCH_ADVERTISER_LIST,
//     payload: {
//       advertiser_list: advertiser_list.filter((data) => data.selected == 'true'),
//       // user_type: 'admin' //advertiser_list.role
//       user_type: advertiser_list.role
//     }
//   };
// };

// New Logic to drop duplicate entry of Advertiser List - After Sep 11, 2025

export const setFetchedAdvertiserList = (advertiser_list) => {
  // Raw response

  console.log('RAW advertiser_list from API:', JSON.stringify(advertiser_list, null, 2));
  console.log('RAW length:', advertiser_list.length);

  const userRole = localStorage.getItem('user_role') || 'client';
  // console.log("User Role:", userRole);

  // Filter by role
  // let filteredAdvertisers;
  // if (userRole === 'admin') {
  //   filteredAdvertisers = advertiser_list;
  //   console.log('Admin user → Keeping all advertisers');
  // } else {
  //   filteredAdvertisers = advertiser_list.filter((data) => data.selected == 'true');
  //   console.log('Client user → Keeping only selected=true advertisers');
  // }

  // Step 1: Filtered Advertiser List
  let filteredAdvertisers = advertiser_list.filter((data) => data.selected === 'true');
  console.log(`${userRole} - Filtered Advertiser count:`, filteredAdvertisers.length);

  // Step 2: Transform
  const transformedAdvertisers = filteredAdvertisers.map((advertiser, idx) => {
    const sfId = advertiser.sfId || advertiser.salesforce_account_id || advertiser.salesForceAccountId || '';

    const transformed = {
      advertiser_guid: advertiser.id || advertiser.advertiser_guid,
      advertiser_name: advertiser.name || advertiser.advertiser_name,
      timezone: advertiser.timezone,
      salesforce_account_id: sfId,
      platform: advertiser.platform,
      start_date: advertiser.start_date
    };

    // console.log(`[${idx}] TRANSFORMED:`, JSON.stringify(transformed));
    return transformed;
  });

  console.log(`${userRole} - Transformed advertisers count:`, transformedAdvertisers.length);

  // Step 3: Deduplicate

  const uniqueAdvertisers = transformedAdvertisers.filter((advertiser, index, self) => {
    return (
      index ===
      self.findIndex((a) => {
        // If SFID is empty, dedupe only by advertiser_guid
        if (!advertiser.salesforce_account_id) {
          return a.advertiser_guid === advertiser.advertiser_guid;
        }
        // If SFID exists, dedupe by both advertiser_guid + SFID
        return a.advertiser_guid === advertiser.advertiser_guid && a.salesforce_account_id === advertiser.salesforce_account_id;
      })
    );
  });

  // console.log("Unique advertisers count:", uniqueAdvertisers.length);
  // console.log("Unique advertisers list:", JSON.stringify(uniqueAdvertisers, null, 2));

  return {
    type: FETCH_ADVERTISER_LIST,
    payload: {
      advertiser_list: uniqueAdvertisers,
      user_type: userRole
    }
  };
};
export const androidCampaignCount = (count) => {
  return {
    type: FETCH_ANDROID_CAMPAIGN_COUNT,
    payload: {
      android_campaign_count: count
    }
  };
};
export const iosCampaignCount = (count) => {
  return {
    type: FETCH_IOS_CAMPAIGN_COUNT,
    payload: {
      ios_campaign_count: count
    }
  };
};

export const fetchedOrgDetails = (details) => {
  return {
    type: FETCH_ORG_LIST,
    payload: details
  };
};

export const fetchedDashboardAllUserList = (details) => {
  return {
    type: FETCH_ALL_DASHBOARD_USER_LIST,
    payload: details
  };
};
// To fetch user associated advertisers along with role type
export const fetchAdvertiserList = (email) => (dispatch) => {
  //console.log(email)

  dispatch(fetchRequest);
  axios({
    method: 'post',
    url: `${BASE_URL}/get_user_advertiser_details`,
    header: {
      'Content-Type': 'application/json'
    },
    data: {
      email: email
    },
    timeout: timeout
  })
    .then((response) => {
      //console.log('response advertiser', response.data.data);
      if (response.data.data.length > 0) {
        return dispatch(setFetchedAdvertiserList(response.data.data));
      } else {
        //console.log("inside fetchAdvertiserListFailure");
        return dispatch(fetchAdvertiserListFailure(''));
      }
    })
    .catch(function (error) {
      //console.log("Show error notification!", error);
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
      //return Promise.reject(error)
    });
};

export const setUserRole = (advertiser_list) => {
  //console.log('advertiser_list', advertiser_list);
  return {
    type: FETCHED_USER_ROLE,
    payload: {
      user_type: advertiser_list.role
    }
  };
};

//export const fetchUserRoleByEmailId = (email) => (dispatch) => {
//  // This function is no longer needed as we get user role from get_all_users_list
//  // Keeping it for backward compatibility but it's deprecated
//  console.warn('fetchUserRoleByEmailId is deprecated. Use get_all_users_list data instead.');
//
//  // Return a resolved promise to prevent errors
//  return Promise.resolve();
//};

export const fetchUserRoleByEmailId = (email) => (dispatch) => {
  //console.log(email)

  dispatch(fetchRequest);
  axios({
    method: 'post',
    url: `${BASE_URL}/getUserRoleBasedOnEmail`,
    header: {
      'Content-Type': 'application/json'
    },
    data: {
      email: email
    },
    timeout: timeout
  })
    .then((response) => {
      //console.log('response advertiser', response.data.data);
      if (response.data.data.length > 0) {
        localStorage.setItem('user_role', response.data.data[0].role);
        return dispatch(setUserRole(response.data.data[0]));
      } else {
        //console.log("inside fetchAdvertiserListFailure");
        return dispatch(fetchAdvertiserListFailure(''));
      }
    })
    .catch(function (error) {
      //console.log("Show error notification!", error);
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
      //return Promise.reject(error)
    });
};

// export const fetchCampaignsForAdvertiser = (advertiser_guid, sfid) => (dispatch) => {
//   dispatch(fetchAdvertiserData(''));
//   axios({
//     method: 'post',
//     url: `${BASE_URL}/getCampaignListForAdvertiser`,
//     header: {
//       'Content-Type': 'application/json'
//     },
//     data: {
//       AdvertiserId: advertiser_guid
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data.data.length > 0) {
//         // console.log(response.data.data)
//         return dispatch(setFetchedCampaignList(response.data.data, sfid));
//       } else {
//         return dispatch(fetchCampaignError('No campaigns are live on Android for this Advertiser.'));
//       }
//     })
//     .catch(function (error) {
//       return dispatch(fetchFailure('Not able to fetch data. Please retry'));
//     });
// };

// fetchCampaignsForAdvertiser - DoD
export const fetchCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch, getState) => {
  const state = getState();
  const timeZone = state.advertiserReducer.timeZone;
  // const { start_date, end_date } = state.campaignReducer;

  // Validate dates
  if (!start_date || !end_date) {
    return dispatch(fetchCampaignError('Please select date range first'));
  }

  console.log('Frontend NonSKAN dates:', { start_date, end_date, timeZone }); //debug log

  // dispatch(fetchAdvertiserData(''));
  axios({
    method: 'post',
    url: `${BASE_URL}/getCampaignListForAdvertiser`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid,
      StartDate: start_date,
      EndDate: end_date,
      Timezone: timeZone
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data.length > 0) {
        return dispatch(setFetchedCampaignList(response.data.data, sfid));
      } else {
        return dispatch(fetchCampaignError('No campaigns are live on Android for this Advertiser.'));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
    });
};

export const fetchCTVCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch) => {
  if (!start_date || !end_date) {
    return dispatch(fetchCampaignError('Please select date range first'));
  }
  axios({
    method: 'post',
    url: `${BASE_URL}/getCampaignListForCtvAdvertiser`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      AdvertiserId: advertiser_guid,
      StartDate: start_date,
      EndDate: end_date
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data && response.data.data.length > 0) {
        return dispatch(setFetchedCampaignList(response.data.data, sfid));
      } else {
        return dispatch(fetchCampaignError('No CTV campaigns found for this Advertiser.'));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch CTV campaigns. Please retry'));
    });
};

export const fetchJSTCampaignsForAdvertiser = (advertiser_guid, sfid) => (dispatch, getState) => {
  let timeZone = getState().advertiserReducer.timeZone;
  dispatch(fetchAdvertiserData(''));
  axios({
    method: 'post',
    url: `${BASE_URL}/getJSTCampaignListForAdvertiser`,
    header: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data.length > 0) {
        // console.log(response.data.data)
        return dispatch(setFetchedCampaignList(response.data.data, sfid));
      } else {
        return dispatch(fetchCampaignError('No campaigns are live on Non-Skan for this Advertiser.'));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
    });
};
export const fetchCampaignsCountForAndroid = (advertiser_guid, sfid) => (dispatch) => {
  dispatch(resetCampaignCount(''));
  axios({
    method: 'post',
    url: `${BASE_URL}/getCampaignListForAdvertiser`,
    header: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid
    },
    timeout: timeout
  })
    .then((response) => {
      // console.log("Activated----><<",response.data.data.length)
      if (response.data.data.length > 0) {
        // console.log(response.data.data)
        return dispatch(androidCampaignCount(1));
      } else {
        return dispatch(androidCampaignCount(0));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
    });
};
export const fetchSkanCampaignsCountForIos = (advertiser_guid, sfid) => (dispatch) => {
  dispatch(resetCampaignCount(''));

  axios({
    method: 'post',
    url: `${BASE_URL}/getSkanCampaignListForAdvertiser`,
    header: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data.length > 0) {
        return dispatch(iosCampaignCount(1));
      } else {
        return dispatch(iosCampaignCount(0));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
    });
};

export const setFetchedCampaignList = (campaignData, sfId) => {
  // Filter out campaigns with invalid names
  const validCampaigns = campaignData.filter(
    (campaign) =>
      campaign.campaign_name &&
      campaign.campaign_name !== 'NaN' &&
      campaign.campaign_name !== null &&
      campaign.campaign_name.trim() !== '' &&
      campaign.campaign_name !== 'undefined'
  );

  console.log('Original campaign count:', campaignData.length);
  console.log('Valid campaign count:', validCampaigns.length);

  return {
    type: FETCH_CAMPAIGN_LIST_BY_ADVERTISER,
    payload: {
      campaign_list: validCampaigns, // Use filtered campaigns
      default_selected_campaigns: validCampaigns.map((value) => value.campaign_guid),
      sfId: sfId
    }
  };
};

export const fetchCampaignsByAdvertiserGuid = (advertiser_guid) => {
  let campaignDetailsForAdvertiser = campaignData.filter((data) => data.advertiserID == advertiser_guid);
  // const selected_Advertiser=getState().advertiserReducer.advertiser_guid;
  //console.log("Action",campaignDetailsForAdvertiser)
  return {
    type: FETCH_CAMPAIGN_LIST_BY_ADVERTISER,
    payload: campaignDetailsForAdvertiser
  };
};
export const setSelectedAdvertiserData = (details) => {
  //console.log(details);
  return {
    type: SET_ADVERTISER,
    payload: details
  };
};
export const setSelectedAdvertiser = (advertiser_name, advertiser_guid) => (dispatch) => {
  //console.log('setSelectedAdvertiser', advertiser_name, advertiser_guid);
  let data = {
    advertiser_guid: advertiser_guid,
    advertiser_name: advertiser_name
  };
  dispatch(setSelectedAdvertiserData(data));
  //  return {
  //         type:SET_ADVERTISER,
  //         payload:data
  //  }
};
// set selected campaign guids as selected by autocomplete
export const setSelectedCampaignList = (campaign_guids) => {
  //console.log('campaign_guids', campaign_guids);
  return {
    type: SET_CAMPIGN_LIST_SELECTED,
    payload: campaign_guids
  };
};
// export const fetchSkanCampaignsForAdvertiser = (advertiser_guid, sfid) => (dispatch, getState) => {
//   let timeZone = getState().advertiserReducer.timeZone
//   dispatch(fetchRequest);
//   //console.log("Activated---->")
//   axios({
//     method: 'post',
//     url: `${BASE_URL}/getSkanCampaignListForAdvertiser`,
//     header: {
//       'Content-Type': 'application/json'
//     },
//     data: {
//       AdvertiserId: advertiser_guid
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data.data.length > 0) {
//         //console.log(response.data.data);
//         return dispatch(setFetchedCampaignList(response.data.data, sfid));
//       } else {
//         let msg = (timeZone == 'JST' ? 'No campaigns are live on SKAN for this Advertiser.' : 'No campaigns are live on iOS for this Advertiser.')
//         return dispatch(fetchCampaignError(msg));
//       }
//     })
//     .catch(function (error) {
//       return dispatch(fetchFailure('Not able to fetch data. Please retry'));
//     });
// };
// fetchSkanCampaignsForAdvertiser - DoD
export const fetchSkanCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch, getState) => {
  let timeZone = getState().advertiserReducer.timeZone;

  // dispatch(fetchRequest('')); // iOS campaign fetch loader issue fix
  // dispatch(fetchAdvertiserData(''));

  axios({
    method: 'post',
    url: `${BASE_URL}/getSkanCampaignListForAdvertiser`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid,
      StartDate: start_date,
      EndDate: end_date,
      Timezone: timeZone
      // Remove: sfId: sfid (not needed for Scenario B)
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data.length > 0) {
        // Pass sfid for Redux context tagging
        return dispatch(setFetchedCampaignList(response.data.data, sfid));
      } else {
        let msg =
          timeZone == 'JST' ? 'No campaigns are live on SKAN for this Advertiser.' : 'No campaigns are live on iOS for this Advertiser.';
        return dispatch(fetchCampaignError(msg));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
    });
};

// Fetch campaigns for multiple quarters and combine
export const fetchCampaignsForQuarters = (advertiser_guid, sfid, quarterRanges, isSkan, signal) => async (dispatch, getState) => {
  const timeZone = getState().advertiserReducer.timeZone;

  console.log('🔍 Fetching campaigns for multiple quarters:', quarterRanges);

  // SHOW LOADER: Set WoW loading state
  dispatch(fetchRequestWow('loading'));

  try {
    // Fetch campaigns for each quarter
    const campaignPromises = quarterRanges.map((range) => {
      const endpoint = isSkan ? '/getSkanCampaignListForAdvertiser' : '/getCampaignListForAdvertiser';

      console.log(`Fetching campaigns for ${range.quarter}:`, {
        start: range.startDate,
        end: range.endDate
      });

      return axios({
        method: 'post',
        url: `${BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          AdvertiserId: advertiser_guid,
          StartDate: range.startDate,
          EndDate: range.endDate,
          Timezone: timeZone
        },
        signal: signal,
        timeout: timeout
      });
    });

    // Wait for all requests to complete
    const responses = await Promise.all(campaignPromises);

    // Combine all campaign data
    const allCampaigns = [];
    const campaignGuids = new Set();

    responses.forEach((response, index) => {
      if (response.data.data && response.data.data.length > 0) {
        console.log(`${quarterRanges[index].quarter}: Found ${response.data.data.length} campaigns`);

        response.data.data.forEach((campaign) => {
          if (!campaignGuids.has(campaign.campaign_guid)) {
            campaignGuids.add(campaign.campaign_guid);
            allCampaigns.push(campaign);
          }
        });
      } else {
        console.log(`⚠️ ${quarterRanges[index].quarter}: No campaigns found`);
      }
    });

    console.log('🎯 Combined campaigns:', {
      total: allCampaigns.length,
      quarters: quarterRanges.map((r) => r.quarter)
    });

    if (allCampaigns.length > 0) {
      dispatch(setFetchedCampaignList(allCampaigns, sfid));

      // HIDE LOADER: Clear WoW loading after campaigns load successfully
      dispatch({ type: CLEAR_WOW_LOADING });

      return;
    } else {
      const msg = isSkan
        ? timeZone === 'JST'
          ? 'No campaigns are live on SKAN for selected quarters.'
          : 'No campaigns are live on iOS for selected quarters.'
        : 'No campaigns are live on Android for selected quarters.';

      // HIDE LOADER (use CLEAR_WOW_LOADING, not FETCH_WOW_REQUEST!)
      dispatch({ type: CLEAR_WOW_LOADING });
      return dispatch(fetchCampaignError(msg));
    }
  } catch (error) {
    // Handle abort/cancellation
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED' || error.message === 'canceled') {
      console.log('✅ Campaign fetch cancelled - user changed selection');
      // HIDE LOADER (use CLEAR_WOW_LOADING!)
      dispatch({ type: CLEAR_WOW_LOADING });
      return;
    }

    // Handle axios abort
    if (axios.isCancel && axios.isCancel(error)) {
      console.log('✅ Campaign fetch cancelled - user changed selection');
      // HIDE LOADER (use CLEAR_WOW_LOADING!)
      dispatch({ type: CLEAR_WOW_LOADING });
      return;
    }

    console.error('Error fetching campaigns for quarters:', error);
    // HIDE LOADER (use CLEAR_WOW_LOADING!)
    dispatch({ type: CLEAR_WOW_LOADING });
    return dispatch(fetchFailure('Not able to fetch data. Please retry'));
  }
};

export const fetchOrgList = () => (dispatch) => {
  axios({
    method: 'post',
    url: `${BASE_URL}/get_org_details`,
    header: {
      'Content-Type': 'application/json'
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data.length > 0) {
        //console.log(response.data.data);
        return dispatch(fetchedOrgDetails(response.data.data));
      } else {
        return dispatch(fetchedOrgDetails([]));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch data. Please retry'));
    });
};

export const filterAdvertiserData = (advertiser_list, search_string) => (dispatch) => {
  //console.log(advertiser_list);
  if (search_string != '') {
    advertiser_list = advertiser_list.filter((item) => item.advertiser_name.toLowerCase().includes(search_string.toLowerCase()));
  }
  //console.log(advertiser_list);
  dispatch(setFilteredAdvertiserData(advertiser_list));
};

export const setFilteredAdvertiserData = (details) => {
  return {
    type: SET_ADVERTISER_FILTERED_DATA,
    payload: details
  };
};

// Redux action
export const fetchAllUserList = () => (dispatch) => {
  axios({
    method: 'post',
    url: `${BASE_URL}/get_all_users_list`,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data?.length > 0) {
        dispatch(fetchedDashboardAllUserList(response.data));
      } else {
        dispatch(fetchedDashboardAllUserList([])); // Dispatch empty list
      }
    })
    .catch((error) => {
      console.error('Fetch users list failed:', error);
      dispatch(fetchFailure('Unable to fetch user list. Please try again.'));
    });
};

// Fetch SKAN campaigns for mailer (separate from existing logic)
export const fetchMailerSkanCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch, getState) => {
  dispatch({ type: FETCH_MAILER_SKAN_CAMPAIGNS_REQUEST });

  // Validate dates - use current dates if not provided
  if (!start_date || !end_date) {
    console.warn('Mailer SKAN: Missing date parameters, using default range');
    const today = new Date();
    start_date = new Date(today.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // T-2
    end_date = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // T-1
  }

  console.log('Fetching Mailer SKAN campaigns with dates:', {
    advertiser_guid,
    start_date,
    end_date
  });

  axios({
    method: 'post',
    url: `${BASE_URL}/getSkanCampaignListForAdvertiser`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid,
      StartDate: start_date,
      EndDate: end_date,
      Timezone: 'UTC', // Fixed for mailer
      sfId: sfid
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data && response.data.data.length > 0) {
        dispatch({
          type: FETCH_MAILER_SKAN_CAMPAIGNS_SUCCESS,
          payload: {
            skan_campaigns: response.data.data,
            sfid: sfid
          }
        });
      } else {
        dispatch({
          type: FETCH_MAILER_SKAN_CAMPAIGNS_SUCCESS,
          payload: {
            skan_campaigns: [],
            sfid: sfid
          }
        });
      }
    })
    .catch((error) => {
      console.error('Error fetching SKAN campaigns for mailer:', error);
      dispatch({
        type: FETCH_MAILER_SKAN_CAMPAIGNS_FAILURE,
        payload: 'Failed to fetch iOS campaigns for mailer'
      });
    });
};

// Fetch regular campaigns for mailer (separate from existing logic)
export const fetchMailerRegularCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch, getState) => {
  dispatch({ type: FETCH_MAILER_REGULAR_CAMPAIGNS_REQUEST });

  // Validate dates - use current dates if not provided
  if (!start_date || !end_date) {
    console.warn('Mailer Regular: Missing date parameters, using default range');
    const today = new Date();
    start_date = new Date(today.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // T-2
    end_date = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // T-1
  }

  console.log('Fetching Mailer Regular campaigns with dates:', {
    advertiser_guid,
    start_date,
    end_date
  });

  axios({
    method: 'post',
    url: `${BASE_URL}/getCampaignListForAdvertiser`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      AdvertiserId: advertiser_guid,
      StartDate: start_date,
      EndDate: end_date,
      Timezone: 'UTC' // Fixed for mailer
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data && response.data.data.length > 0) {
        dispatch({
          type: FETCH_MAILER_REGULAR_CAMPAIGNS_SUCCESS,
          payload: {
            regular_campaigns: response.data.data,
            sfid: sfid
          }
        });
      } else {
        dispatch({
          type: FETCH_MAILER_REGULAR_CAMPAIGNS_SUCCESS,
          payload: {
            regular_campaigns: [],
            sfid: sfid
          }
        });
      }
    })
    .catch((error) => {
      console.error('Error fetching regular campaigns for mailer:', error);
      dispatch({
        type: FETCH_MAILER_REGULAR_CAMPAIGNS_FAILURE,
        payload: 'Failed to fetch Android campaigns for mailer'
      });
    });
};

// Combined fetch function for mailer
export const fetchMailerCombinedCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch) => {
  // Clear previous campaigns first
  dispatch(clearMailerCampaigns());

  // Validate dates - use current dates if not provided
  if (!start_date || !end_date) {
    console.warn('Mailer Combined: Missing date parameters, using default range');
    const today = new Date();
    start_date = new Date(today.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // T-2
    end_date = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // T-1
  }

  console.log('Fetching Mailer Combined campaigns with dates:', {
    advertiser_guid,
    sfid,
    start_date,
    end_date
  });

  // Fetch both campaign types with date parameters
  dispatch(fetchMailerSkanCampaignsForAdvertiser(advertiser_guid, sfid, start_date, end_date));
  dispatch(fetchMailerRegularCampaignsForAdvertiser(advertiser_guid, sfid, start_date, end_date));
};

export const fetchGTVCampaignsForAdvertiser = (advertiser_guid, sfid, start_date, end_date) => (dispatch) => {
  if (!start_date || !end_date) {
    return dispatch(fetchCampaignError('Please select date range first'));
  }
  axios({
    method: 'post',
    url: `${BASE_URL}/getCampaignListForGtvAdvertiser`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      AdvertiserId: advertiser_guid,
      StartDate: start_date,
      EndDate: end_date
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data.data && response.data.data.length > 0) {
        return dispatch(setFetchedCampaignList(response.data.data, sfid));
      } else {
        return dispatch(fetchCampaignError('No GTV campaigns found for this Advertiser.'));
      }
    })
    .catch(function (error) {
      return dispatch(fetchFailure('Not able to fetch GTV campaigns. Please retry'));
    });
};
